<template>
  <TopGradientBlockLayout class="h-full">
    <div class="text-xl font-bold text-text leading-tight mb-3">
      {{ $t('title', {month: filter_month_name}) }}
    </div>
    <p class="text-sm text-text-ternary leading-normal" v-html="$t('text',{month:filter_month_name})"></p>
  </TopGradientBlockLayout>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";

export default {
  name: "BudgetCreateBlock",
  components: {TopGradientBlockLayout},
  computed: {
    ...mapState('space/budgets', ['filters']),
    ...mapGetters('space/budgets', ['filter_month_name'])
  },
  i18n: {
    messages: {
      en: {
        title: 'My budget on {month}',
        text: 'Budget planning is a key element in controlling personal finances. <br> Create your financial plan for {month} right now!'
      },
      ru: {
        title: 'Мой бюджет на {month}',
        text: 'Планирование бюджетов - ключевой элемент в контроле личных финансов.<br> Создайте свой финансовый план на {month} прямо сейчас!'
      }
    }
  }
}
</script>